import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';

export function browserOnly<T>(platformId: Object, fallback: T, request: () => Observable<T>): Observable<T> {
  if (!isPlatformBrowser(platformId)) {
    return of(fallback);
  }

  return request();
}
